enum RoleType {
  Management = 'MANAGEMENT',
  Leader = 'LEADER',
  Employee = 'EMPLOYEE',
  BaseUser = 'BASE_USER',
  Recruiter = 'RECRUITER',
  HR = 'HR',
  ProjectLeader = 'PROJECT_LEADER',
  Admin = 'ADMINISTRATOR',
}

export type RoleName =
  | RoleType.BaseUser
  | RoleType.Employee
  | RoleType.Leader
  | RoleType.Management
  | RoleType.Recruiter
  | RoleType.HR
  | RoleType.ProjectLeader
  | RoleType.Admin

export default RoleType
